import { EMBED_PATH_PREFIX } from "@/constants/embed";

/**
 * DL-452 — Boot-time key for the Academy embed.
 *
 * The global guard is opt-in, so a route without `meta.requires` already passes cleanly. But
 * several points run BEFORE the router resolves its first navigation, where
 * `router.currentRoute` is still START_LOCATION and `meta` is empty:
 *   - `Sentry.init` in src/main.js (before the Vue root is instantiated)
 *   - `created()` and `beforeMount()` in src/App.vue (the global `beforeEach` is async)
 * For those the pathname is the only signal available. After navigation resolves (the router's
 * afterEach, Apollo's errorLink) `meta.embed` is used, which is more precise.
 *
 * Compares by segment rather than with a bare startsWith: a future `/embedded-reports` must not
 * inherit the embed bypasses.
 *
 * @param {string} [pathname] pathname to evaluate; falls back to window.location.pathname
 * @returns {boolean} true when the route belongs to the embed
 */
export const isEmbedPath = (pathname) => {
  const path =
    typeof pathname === "string" ? pathname : window?.location?.pathname;

  if (typeof path !== "string") return false;

  return path === EMBED_PATH_PREFIX || path.startsWith(`${EMBED_PATH_PREFIX}/`);
};
